<style src="css/courseDetail.css" scoped></style>
<template>
  <div style="padding-top: 1rem; padding-bottom: 1rem">
    <topbar text="课程视频" :status="true"></topbar>
    <!--        <div class="fixedBox">-->
    <!--            <div class="topBox">-->
    <!--                <div class="backIcon" @click="back"></div>-->
    <!--                <div class="topTitle"></div>-->
    <!--                &lt;!&ndash;<div class="rule" @click="ruleStatus=true"></div>&ndash;&gt;-->
    <!--                <div></div>-->
    <!--            </div>-->
    <!--        </div>-->
    <div class="videoBox">
      <video
        :src="microDetail.new_source_url"
        :poster="microDetail.pic"
        controls
        webkit-playsinline=""
        playsinline=""
        x5-playsinline=""
        x-webkit-airplay="allow"
      ></video>
      <div class="zhezhao" v-if="!(microDetail.payType == 0 || orderNo)"></div>
    </div>
    <div class="videoTopBox">
      <div class="videoTitle">{{ microDetail.name }}</div>
      <div class="topCenterBox">
        <div class="topLeft">
          <div class="videoIcon">视频</div>
          {{ microDetail.readCount }}人已参加
        </div>
        <!--                <div class="topRight">免费</div>-->
      </div>
    </div>
    <!--        <div class="doctorMainBox">-->

    <!--        </div>-->
    <div class="videoMain">
      <div class="mainTitleBox">
        <div class="mainJj active">内容</div>
        <!--                <div class="mainMl">目录</div>-->
      </div>
      <div class="mainContent">
        <div class="kcjj">
          <!--                    <div class="black"></div>-->
          <!--                    <span>课程内容</span>-->
          <!--                    <div class="black"></div>-->
        </div>
        <div class="mainWord">{{ microDetail.text }}</div>
        <!--                <div class="clickBox">-->
        <!--                    <div class="handBase">-->
        <!--                        <div class="hand" :class="{actived:handMove}"></div>-->
        <!--                    </div>-->
        <!--                    <div class="boldWord">问题没解决？找专家咨询一下</div>-->
        <!--                    <div class="allDay">知名专家24小时回复</div>-->
        <!--                    <div class="clickBtn" @click="to('ask')"></div>-->
        <!--                </div>-->
      </div>
    </div>
    <div class="catalogueBox">
      <div class="catalogueBoxTitle">课程目录</div>
      <div class="catalogueCountBox">{{ courseList.length }}节系列课</div>
      <div class="catalogueListBox">
        <div
          class="catalogueItemBox"
          v-for="(item, index) in courseList"
          :key="index"
          @click="change(item.courseUrl)"
        >
          <img
            src="~assets/catalogueB.png"
            v-if="microDetail.payType == 0 || orderNo"
            alt=""
          />
          <img src="~assets/catalogueS.png" v-else alt="" />
          {{ index + 1 }}.{{ item.courseName }}
        </div>
      </div>
    </div>
    <div
      class="commentBox"
      v-if="microCommentList && microCommentList.length > 0"
    >
      <div class="modeTitle">
        全部评论({{ count }}):
        <div></div>
      </div>
      <ul>
        <li v-for="item in microCommentList">
          <div class="userBox">
            <div class="userImg"></div>
            <div class="userTopRightBox">
              <div class="name">{{ item.nickName }}</div>
              <div class="time">{{ item.createTime | time }}</div>
            </div>
          </div>
          <div class="userContent">{{ item.content }}</div>
        </li>
      </ul>
    </div>
    <div class="maskBox" v-if="mask">
      <div class="inputBox">
        <div class="inputTop">
          <span @click="cancle()">取消</span>
          <span @click="commitMicroComment">提交</span>
        </div>
        <textarea
          autofocus
          id="textarea"
          v-model="content"
          placeholder="写下你的看法吧！"
        ></textarea>
      </div>
    </div>
    <div class="fixedBox" v-if="microDetail.payType == 0 || orderNo">
      <div class="input" @click="openMask()">
        <div class="inputIcon"></div>
        写下你的看法吧！
      </div>
      <div
        class="fabulous"
        :class="{ actived: likeStatus }"
        @click="doLoveMicro()"
      >
        <div class="c-num">{{ microDetail.loveCount }}</div>
      </div>
      <div class="toTeacher" @click="to('ask')">咨询老师</div>
    </div>
    <div class="fixedBox" v-else @click="showPayMask">
      <div class="btn">
        购买系列课<span>￥</span>{{ microDetail.microPrice }}
      </div>
    </div>
    <pay
      v-if="payMask"
      @close="closeMask"
      :price="microDetail.microPrice"
      :microId="microDetail.microId"
      bookId=""
    ></pay>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";

import noMoreData from "components/no-more-data";
import topbar from "components/topbar";
import moment from "moment/moment";
import pay from "components/payAssembly"
import { Swiper, Slide } from "vue-swiper-component";
import { serialize } from "utils/index";

export default {
  data() {
    return {
      handMove: false,
      mask: false,
      payMask:false,
      content: "",
      likeStatus: false,
      microId: "",
      microCommentList: [],
      courseList: [],
      microDetail: {},
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      userId: "",
      pageIndex: 1,
      pageSize: 4,
      noMoreData: false,
      isLoading: false,
      count: 0,
      companyId: localStorage.getItem("companyId")
        ? localStorage.getItem("companyId")
        : "",
      orderNo: "",
    };
  },
  components: {
    noMoreData,
    topbar,
    Swiper,
    Slide,
    pay,
  },
  filters: {
    time(value) {
      let transTime = moment(value).format("YYYY-MM-DD HH:mm:ss");
      return transTime;
    },
  },
  computed: {},
  methods: {
    showPayMask(){
      this.payMask = true
    },
    closeMask() {
      this.payMask = false;
    },
    change(url) {
      if (this.microDetail.payType == 0 || this.orderNo) {
        this.microDetail.new_source_url = url;
      } else {
      }
    },
    cancle() {
      this.mask = false;
    },
    openMask() {
      this.mask = true;
    },
    back() {
      history.back();
    },
    init() {
      this.content = "";
      this.mask = false;
    },
    async commitMicroComment() {
      if (!this.content) {
        alert("请您输入评论内容~");
      } else {
        let data = await getSources(
          "/bear-scale/api/micro/commitMicroComment.json",
          {
            microId: this.microId,
            userId: this.userId,
            content: this.content,
          }
        );
        if (data.status === 0) {
          this.getMicroCommentList();
          this.init();
        } else {
          alert(data.msg);
        }
      }
    },
    to(n) {
      this.$router.push(`/${n}`);
    },
    async getMicroCommentList() {
      let data = await getSources(
        "/bear-scale/api/micro/getMicroCommentList.json",
        {
          pageIndex: 1,
          pageSize: 20,
          microId: this.microId,
        }
      );
      if (data.status === 0) {
        this.microCommentList = data.microCommentList;
        this.count = data.count;
      } else {
        alert(data.msg);
      }
    },
    async doLoveMicro() {
      let data = await getSources("/bear-scale/api/micro/doLoveMicro.json", {
        microId: this.microId,
      });
      if (data.status === 0) {
        this.likeStatus = true;
        this.getMicroDetail();
      }
    },
    async getMicroDetail() {
      let obj = {};
      obj.microId = this.$route.query.microId;
      obj.companyId = localStorage.getItem("companyId")
        ? localStorage.getItem("companyId")
        : "";
      let data = await getSources(
        "/bear-scale/api/micro/getMicroDetail.json",
        obj
      );
      if (data.status === 0) {
        this.microDetail = data.microDetail;
        this.courseList = data.courseList;
      } else {
        alert(data.msg);
      }
    },

    handtoggle() {
      setInterval(() => {
        this.handMove = !this.handMove;
      }, 500);
    },
  },
  mounted() {
    if (!localStorage.getItem("userId")) {
      if (this.$route.query.code) {
        this.$router.push(
          `/login?next=${encodeURIComponent(this.$route.fullPath)}&code=${
            this.$route.query.code
          }`
        );
      } else {
        this.$router.push(
          `/login?next=${encodeURIComponent(this.$route.fullPath)}`
        );
      }
      return;
    }
    document.scrollingElement.scrollTop = 0;
    document.scrollingElement.scrollLeft = 0;
    this.microId = this.$route.query.microId;
    this.orderNo = this.$route.query.orderNo?this.$route.query.orderNo:'';
    this.userId = localStorage.getItem("userId");
    this.getMicroDetail();
    this.getMicroCommentList();
    this.handtoggle();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/courseDetail.vue?fe6b47d8